// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__27CLn","info":"PatientInfo_info__21ba-"};